export default __webpack_public_path__ + "static/media/ic-agency-inactive.10f6b478.webp";